import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarTile } from "@perxis-auto/ui-kit/lib/components/CarTile";
const TilePrice = memo(function TilePrice2({ isLoading = false, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarTile.PriceSkeleton, {});
  }
  return /* @__PURE__ */ jsx(CarTile.Price, { ...props });
});
export {
  TilePrice
};
